import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    returns: [],
    returnContext: null,
    productReturn: null,
  },

  getters: {
    returns(state) {
      return state.returns
    },
    returnContext(state) {
      return state.returnContext
    },
    productReturn(state) {
      return state.productReturn
    },
  },

  mutations: {
    SET_RETURNS(state, value) {
      state.returns = value
    },
    SET_RETURN_CONTEXT(state, value) {
      state.returnContext = value
    },
    SET_PRODUCT_RETURN(state, value) {
      state.productReturn = value
    },
    REMOVE_RETURN(state, id) {
      state.returns = state.returns.filter((item) => item.id !== id)
    },
  },

  actions: {
    loadBySale({ commit }, saleId) {
      return axios.get(`api/sales/${saleId}/returns`).then((response) => {
        const data = response.data.data ?? response.data
        commit('SET_RETURNS', data)
        return data
      })
    },
    loadReturnContext({ commit }, { saleId, excludeReturnId = null }) {
      const params = excludeReturnId ? { exclude_return_id: excludeReturnId } : {}
      return axios.get(`api/sales/${saleId}/return-context`, { params }).then((response) => {
        const data = response.data.data ?? response.data
        commit('SET_RETURN_CONTEXT', data)
        return data
      })
    },
    loadReturn({ commit }, returnId) {
      return axios.get(`api/returns/${returnId}`).then((response) => {
        const data = response.data.data ?? response.data
        commit('SET_PRODUCT_RETURN', data)
        return data
      })
    },
    createReturn(_, { saleId, payload }) {
      return axios.post(`api/sales/${saleId}/returns`, payload).then((response) => {
        return response.data.data ?? response.data
      })
    },
    updateReturn(_, { id, payload }) {
      return axios.put(`api/returns/${id}`, payload).then((response) => {
        return response.data.data ?? response.data
      })
    },
    deleteReturn({ commit }, id) {
      return axios.delete(`api/returns/${id}`).then((response) => {
        commit('REMOVE_RETURN', id)
        return response.data
      })
    },
  },
}
